import {
  EMOJI_CDN_URLS,
  EMOJI_CDN_PROVIDER,
  type EmojiCdnProviderType
} from 'widget/consts/emoji';

export const EMOJI_REGEX =
  /(\p{Extended_Pictographic}(?:\uFE0F|\u200D\p{Extended_Pictographic})*)/gu;

export function emojiToCdnUrl(
  emoji: string,
  provider: EmojiCdnProviderType = EMOJI_CDN_PROVIDER
): string | null {
  const baseUrl = EMOJI_CDN_URLS[provider];

  if (!baseUrl) {
    return null;
  }

  const codePoints: string[] = [];

  for (const char of emoji) {
    const cp = char.codePointAt(0);
    if (cp !== undefined) {
      codePoints.push(cp.toString(16));
    }
  }

  return `${baseUrl}/${codePoints.join('-')}.png`;
}

export type EmojiSegment =
  | { type: 'text'; value: string }
  | { type: 'emoji'; value: string };

export function parseTextWithEmoji(text: string): EmojiSegment[] {
  const segments: EmojiSegment[] = [];
  let lastIndex = 0;

  EMOJI_REGEX.lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = EMOJI_REGEX.exec(text)) !== null) {
    if (match.index > lastIndex) {
      segments.push({
        type: 'text',
        value: text.slice(lastIndex, match.index)
      });
    }
    segments.push({ type: 'emoji', value: match[0] });
    lastIndex = EMOJI_REGEX.lastIndex;
  }

  if (lastIndex < text.length) {
    segments.push({ type: 'text', value: text.slice(lastIndex) });
  }

  return segments;
}

export function isNativeEmojiMode(): boolean {
  return EMOJI_CDN_URLS[EMOJI_CDN_PROVIDER] === null;
}
